import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// Step 1 post api kyc
export const CreateKyc_Step1 = createAsyncThunk(
  "/user/kycidentifyverification",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Kyc.Kyc_Step1, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const CreatePersonalDetail_Step2 = createAsyncThunk(
  "/user/personalDetails",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Kyc.CreatePersonalDetail_Step2, data);

      if (!res?.success) {
        return rejectWithValue(res); // 👈 send full backend response
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: error.message },
      );
    }
  },
);

export const CreateBankDetail_Step3 = createAsyncThunk(
  "/user/BankDetail",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Kyc.CreateBankDetail_Step3, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetStepsDetail = createAsyncThunk(
  "/user/KycReviewDetails",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Kyc.GetStepsDetail);

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "kyc",
  initialState: {
    data: null,
    status: IDS.SLICESTATUS.Idle,
    error: null,
    stepdetail: {},
  },
  reducers: {
    resetContactState: (state) => {
      state.data = null;
      state.status = IDS.SLICESTATUS.Idle;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(CreateKyc_Step1.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(CreateKyc_Step1.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload.data;
      })
      .addCase(CreateKyc_Step1.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(CreatePersonalDetail_Step2.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(CreatePersonalDetail_Step2.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload.data;
      })
      .addCase(CreatePersonalDetail_Step2.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(CreateBankDetail_Step3.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(CreateBankDetail_Step3.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload.data;
      })
      .addCase(CreateBankDetail_Step3.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetStepsDetail.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetStepsDetail.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.stepdetail = action.payload?.data || {};
      })
      .addCase(GetStepsDetail.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export const { resetContactState } = Slice.actions;
export default Slice.reducer;
